import { useState } from 'react';
import { ApprovalContext } from '../context/approvalContext';
import { withApproval } from '../hoc/withApproval';
import { ApprovalModal } from './modal/ApprovalModal';
// @ts-expect-error dependency missing types
import FeedbackLoader from 'feedback-loader';
import enviro from 'enviro';
import { ApprovalOperation } from '../types/ApprovalOperation';
import { ApprovalEditPanel } from './editPanel/ApprovalEditPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalProvider = ({
  children,
  approval,
  modalAlertContent,
  modalAlertOnRequestSuccess
}) => {
  const showModal = approval.meta.showModal;
  const currentOperation = approval.meta.currentOperation;
  const showApprovalEditPanel = approval.meta.showApprovalEditPanel;

  // Feedback survey for approvers and requesters.
  const SURVEY_ID_APPROVER = enviro.isQa() ? 253 : 802;
  const SURVEY_ID_REQUESTER = enviro.isQa() ? 252 : 801;
  const [showSurvey, setShowSurvey] = useState(false);
  const showFeedbackSurvey = () => {
    setShowSurvey(true);
  };
  const getSurveyID = () => {
    if (currentOperation === ApprovalOperation.REQUEST) {
      return SURVEY_ID_REQUESTER;
    } else if (currentOperation === ApprovalOperation.APPROVE) {
      return SURVEY_ID_APPROVER;
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(ApprovalContext.Provider, {
    value: approval,
    children: [children, showModal && /*#__PURE__*/_jsx(ApprovalModal, {
      onClose: () => {
        approval.meta.setShowModal(false);
        approval.meta.setCurrentOperation(null);
      },
      alertContent: modalAlertContent,
      onRequestSuccess: modalAlertOnRequestSuccess,
      showFeedbackSurvey: showFeedbackSurvey
    }), showApprovalEditPanel && /*#__PURE__*/_jsx(ApprovalEditPanel, {
      approvalAction: approval.meta.approvalAction,
      approvalType: approval.meta.approvalType,
      onClose: () => {
        approval.meta.setShowApprovalEditPanel(false);
      }
    }), showSurvey && getSurveyID() ? /*#__PURE__*/_jsx(FeedbackLoader, {
      onClientLoad: feedbackClient => {
        feedbackClient.loadSurvey('CSAT', getSurveyID());
      }
    }) : '']
  });
};
const ApprovalProviderWithApproval = withApproval(ApprovalProvider);
export { ApprovalProviderWithApproval as ApprovalProvider };
/*
 * TestUIUnwrappedApprovalProvider should only be used in our Test UI.
 */
export { ApprovalProvider as TestUIUnwrappedApprovalProvider };